import {PAGE_SIZE} from '@app/core/config/grid.config';

import {State} from '@progress/kendo-data-query';

export const GridState: State = {
  filter:  {
    logic: 'and', filters: []
  }, skip: 0, sort: [],
  take:    PAGE_SIZE
};
